module.exports = __webpack_public_path__ + "img/order_restaurant.f7e4e7eb.png";